import { render, staticRenderFns } from "./TechadressButton.vue?vue&type=template&id=6ebb1d88"
import script from "./TechadressButton.vue?vue&type=script&lang=js"
export * from "./TechadressButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports